import { useEffect, useState } from "react";
import api from "@/lib/api";
import { MapPin, Storefront } from "@phosphor-icons/react";
import { card, inputCls } from "./shared";
import { BusinessCard } from "./BusinessCard";
import { RequestDialog } from "./RequestDialog";

export function LocationExplorer({ categories = [], initialLocation = null }) {
  const [cat, setCat] = useState("");
  const [term, setTerm] = useState("");
  const [debounced, setDebounced] = useState("");
  useEffect(() => { const t = setTimeout(() => setDebounced(term.trim()), 350); return () => clearTimeout(t); }, [term]);
  const [locations, setLocations] = useState([]);
  const [active, setActive] = useState(null);
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  const [requestFor, setRequestFor] = useState(null);

  useEffect(() => { api.get("/market/locations").then(({ data }) => {
    setLocations(data);
    if (initialLocation) setActive(data.find((l) => l.key === initialLocation.toLowerCase()) || null);
  }).catch(() => {}); }, [initialLocation]);
  useEffect(() => {
    if (!active) return;
    api.get("/market/businesses", { params: { location: active.key, ...(cat ? { category: cat } : {}), ...(debounced ? { q: debounced } : {}) } })
      .then(({ data }) => setList(data)).catch(() => setList([]));
  }, [active, cat, debounced]);

  const shown = locations.filter((l) => l.name.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-5">
      <div className={`${card} p-5`}>
        <p className="text-xs font-bold uppercase tracking-widest text-sky-600 mb-3 flex items-center gap-2"><MapPin size={16} weight="bold" /> Choose a location</p>
        <input data-testid="location-search" className={`${inputCls} mb-3`} placeholder="Search locations…" value={q} onChange={(e) => setQ(e.target.value)} />
        <div className="flex flex-wrap gap-2" data-testid="location-list">
          {shown.length === 0 && <p className="text-sm text-sky-700/70">No businesses are live yet. Be the first to register!</p>}
          {shown.map((l) => (
            <button key={l.key} data-testid={`location-btn-${l.key.replace(/\s+/g, "-")}`} onClick={() => setActive(l)}
              className={`h-10 px-4 rounded-full text-sm font-semibold border transition-colors ${active?.key === l.key ? "bg-sky-700 text-white border-sky-700" : "bg-white text-sky-800 border-sky-200 hover:bg-sky-50"}`}>
              {l.name} <span className="opacity-70">· {l.count}</span>
            </button>
          ))}
        </div>
      </div>

      {active && (
        <div className="space-y-4" data-testid="business-list">
          <h2 className="font-heading text-lg font-black text-sky-950 flex items-center gap-2">
            <Storefront size={20} weight="fill" className="text-sky-500" /> Businesses in {active.name}
          </h2>
          <input data-testid="business-search" className={inputCls} placeholder={`Search businesses or items in ${active.name}…`}
            value={term} onChange={(e) => setTerm(e.target.value)} />
          <div className="flex gap-2 overflow-x-auto pb-1" data-testid="category-filter">
            {["", ...categories].map((c) => (
              <button key={c || "all"} data-testid={`category-btn-${(c || "all").replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`} onClick={() => setCat(c)}
                className={`shrink-0 h-9 px-3 rounded-full text-xs font-bold border transition-colors ${cat === c ? "bg-sky-950 text-white border-sky-950" : "bg-white text-sky-800 border-sky-200 hover:bg-sky-50"}`}>
                {c || "All"}
              </button>
            ))}
          </div>
          {list.length === 0 && <p className="text-sm text-sky-700/70">{debounced ? `No results for "${debounced}".` : "No businesses here yet."}</p>}
          <div className="grid md:grid-cols-2 gap-4">
            {list.map((b) => <BusinessCard key={b.business_id} b={b} onRequest={setRequestFor} />)}
          </div>
        </div>
      )}
      <RequestDialog business={requestFor} onClose={() => setRequestFor(null)} />
    </div>
  );
}
